import React from 'react';
import './Typography.scss';

export type TypographyProps = {
    intrinsic: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p' | 'span';
    variant?: 'secondary' | 'sub1' | 'sub2' | 'p2' | 'p3' | 'big' | 'number';
    align?: 'left' | 'center' | 'right';
    defaultSpacing?: boolean;
    preLine?: boolean;
    color?: 'primary' | 'secondary' | 'grey1' | 'purple-cosem' | 'blue-cosem' | 'white' | 'marine' | 'error';
    flex?: boolean;
} & React.HTMLAttributes<HTMLHeadingElement | HTMLParagraphElement | HTMLSpanElement>;

export const Typography: React.FC<TypographyProps> = ({
    children,
    intrinsic,
    variant,
    align,
    defaultSpacing = false,
    color,
    preLine = false,
    flex = false,
    ...props
}) => {
    const Component = intrinsic;
    return (
        <Component
            {...props}
            className={`${props.className ?? ''} ${flex ? 'typography-flex' : ''}`}
            data-variant={variant}
            data-default-spacing={defaultSpacing}
            data-color={color}
            data-align={align}
            data-pre-line={preLine}
        >
            {children}
        </Component>
    );
};
